import { useEffect } from "react";
import { useSelector } from "react-redux";

export function useError(cb) {
  const errors = useSelector((state) => state.locations.errors);
  const status = useSelector((state) => state.locations.status);

  useEffect(() => {
    if (status === "success") {
      cb();
    }
  }, [status]);

  return { errors };
}
